<template>
  <div class="br-pricing">
    <div class="br-pricing__wrapper">
      <div class="br-lead br-lead--full br-lead--center">
        <div class="br-lead__wrapper">
          <h1>Simple pricing to meet your needs</h1>
          <h2>Zenvoy provides custom proposals based on your organization's unique needs.</h2>
        </div>
      </div>

      <div class="br-pricing-chart">
        <div class="br-pricing-chart__panel br-pricing-chart__panel--sidebar">
          <div class="br-pricing-chart__col">
            <div class="br-pricing-chart__head">
              <div class="br-pricing-chart__block">
                <h2>Estimate <span>{{ model.size | numeral }}</span> team members:</h2>
                <slider
                  v-model="model.size"
                  type="size"
                  :min="10000"
                  :max="250000"/>
                <div class="switch-list">
                  <div class="switch-list__item">
                    <label
                      for=""
                      class="label">Billed Yearly Saved 10%</label>
                    <div class="switch">
                      <input
                        v-model="model.yearly"
                        type="checkbox"
                        class="switch__input"
                        checked="checked">
                      <div class="switch__head"/>
                      <div class="switch__decoy"/>
                    </div>
                  </div>
                </div>
                <p>Compare plans and choose the features that best suit your organization's goals. We will estimate your setup and monthly costs based on the options you need.</p>
              </div>
            </div>
            <div class="br-pricing-chart__body">
              <div
                :class="{ 'br-pricing-chart__block--active': activeAiNetworking }"
                class="br-pricing-chart__block">
                <div class="br-pricing-chart__heading">
                  <h2>A.I. Networking</h2>
                  <button
                    class="button button--icon"
                    @click.prevent="toggleAiNetworking">
                    <i
                      :class="[ activeAiNetworking ? 'icon-e-delete' : 'icon-e-add' ]"
                      class="icon"/>
                  </button>
                </div>
                <div class="br-pricing-chart__list">
                  <div class="br-pricing-chart__item">
                    <span class="text">A.I. Matching & Intros</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Organize and structure intelligent introductions between your people utilizing an algorithm you design."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Virtual Business Cards</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Provide your people with a personalized “mini-site” showcasing your organization’s unique brand. Help convert leads by sharing their digital identity."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Watercooler Cohorts</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Strategically arrange your people in cohorts to discuss questions you design. Foster valuable internal relationships, ideas, and team building opportunities. "
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Custom A.I. Tools</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Let us know what custom A.I. tools your organization is looking for- there’s a good chance we can build it!"
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                </div>
              </div>

              <div
                :class="{ 'br-pricing-chart__block--active': activeEngagement }"
                class="br-pricing-chart__block">
                <div class="br-pricing-chart__heading">
                  <h2>Engagement</h2>
                  <button
                    class="button button--icon"
                    @click.prevent="toggleEngagement">
                    <i
                      :class="[ activeEngagement ? 'icon-e-delete' : 'icon-e-add' ]"
                      class="icon"/>
                  </button>
                </div>
                <div class="br-pricing-chart__list">
                  <div class="br-pricing-chart__item">
                    <span class="text">Email Digests</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Keep your people in the loop with a personalized email digests of your organization’s networking activity. "
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Interest Groups</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Create unique online discussion groups. Harness the power of A.I. to bring your people together around what matters. "
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Direct Messaging</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Allow your people to communicate in private with fellow colleagues."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Email Notifications</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Keep your people in the know by designing white-labeled email templates showcasing your organizations networking community. "
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Live Streaming</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Showcase live events, seminars, and presentations directly to your networking community. Allow real-time comments, media and audience reactions."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                </div>
              </div>

              <div
                :class="{ 'br-pricing-chart__block--active': activeAdministration }"
                class="br-pricing-chart__block">
                <div class="br-pricing-chart__heading">
                  <h2>Administration</h2>
                  <button
                    class="button button--icon"
                    @click.prevent="toggleAdministration">
                    <i
                      :class="[ activeAdministration ? 'icon-e-delete' : 'icon-e-add' ]"
                      class="icon"/>
                  </button>
                </div>
                <div class="br-pricing-chart__list">
                  <div class="br-pricing-chart__item">
                    <span class="text">Community Management</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Zenvoy will manage and support the day-to-day tasks required to keep your community running smoothly."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Analytics Dashboard</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Take full control of your community’s A.I. networking:  manage profiles, edit dashboards, view trends, refine algorithms, etc."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Single Sign-on (SSO)</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Zenvoy can integrate SSO with a host of off the shelf community and data management apps. We can also build custom integrations, contact us for more information."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Dedicated Server</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Standalone data handling is available for clients requiring a higher level of data security."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Custom Integrations</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="Zenvoy can provide support for your organization’s custom data feeds."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                  <div class="br-pricing-chart__item">
                    <span class="text">Custom Data Handling</span>
                    <span
                      v-tippy="{ placement:'top', arrow:true }"
                      content="While Zenvoy is compliant HIPPA and SOC2 compliant, we can work with your organization to meet custom data handling procedures."
                      class="br-pricing-chart__note">
                      <i class="icon icon-c-question"/>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="br-pricing-chart__foot">
              <div class="br-pricing-chart__block">
                <p>Non-profit pricing available,<br><a href="">contact us</a></p>
              </div>
            </div>
          </div>
        </div>

        <div class="br-pricing-chart__panel br-pricing-chart__panel--main">
          <div class="br-pricing-chart__controls">
            <button class="br-pricing-chart__controls__prev">
              <i class="icon icon-small-left"/>
            </button>
            <button class="br-pricing-chart__controls__next">
              <i class="icon icon-small-right"/>
            </button>
          </div>

          <div class="br-pricing-chart__row">
            <div class="br-pricing-chart__col">
              <div class="br-pricing-chart__head">
                <div class="br-pricing-chart__block">
                  <h1>Standard</h1>
                  <div class="br-pricing-chart__group">
                    <div class="text-group">
                      <h4>{{ formatNumber(getPerMemberCost(2), '0,0.00') }}</h4>
                      <span class="text text--muted">person<br>/ mo</span>
                    </div>
                  </div>
                  <div class="br-pricing-chart__group">
                    <div class="text-group-vertical">
                      <span class="text text--highlight">Total {{ formatNumber(getMonthlyCostWithAddOns(2)) }} / month</span>
                      <span class="text text--muted">billed {{ model.yearly ? 'annually' : 'monthly' }} <br>+ setup charge</span>
                    </div>
                  </div>
                  <div class="br-pricing-chart__group u-pos-bottom">
                    <a
                      href="/schedule-demo"
                      class="button u-border-radius">
                      Talk to sales
                    </a>
                    <a href="/products/ai-networking-basic-summary">Learn More</a>
                  </div>
                </div>
              </div>
              <div class="br-pricing-chart__body">
                <div
                  :class="{ 'br-pricing-chart__block--active': activeAiNetworking }"
                  class="br-pricing-chart__block">
                  <div class="br-pricing-chart__heading">
                    <h2>A.I. Networking</h2>
                    <button
                      class="button button--icon"
                      @click.prevent="toggleAiNetworking">
                      <i
                        :class="[ activeAiNetworking ? 'icon-e-delete' : 'icon-e-add' ]"
                        class="icon"/>
                    </button>
                  </div>
                  <div class="br-pricing-chart__list">
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Organize and structure intelligent introductions between your people utilizing an algorithm you design."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">A.I. Matching & Intros</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Provide your people with a personalized “mini-site” showcasing your organization’s unique brand. Help convert leads by sharing their digital identity."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Virtual Business Cards</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Strategically arrange your people in cohorts to discuss questions you design. Foster valuable internal relationships, ideas, and team building opportunities. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Watercooler Cohorts</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Let us know what custom A.I. tools your organization is looking for- there’s a good chance we can build it!"
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Custom A.I. Tools</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  :class="{ 'br-pricing-chart__block--active': activeEngagement }"
                  class="br-pricing-chart__block">
                  <div class="br-pricing-chart__heading">
                    <h2>Engagement</h2>
                    <button
                      class="button button--icon"
                      @click.prevent="toggleEngagement">
                      <i
                        :class="[ activeEngagement ? 'icon-e-delete' : 'icon-e-add' ]"
                        class="icon"/>
                    </button>
                  </div>
                  <div class="br-pricing-chart__list">
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Keep your people in the loop with a personalized email digests of your organization’s networking activity. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Email Digests</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Create unique online discussion groups. Harness the power of A.I. to bring your people together around what matters. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Interest Groups</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Allow your people to communicate in private with fellow colleagues."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Direct Messaging</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Keep your people in the know by designing white-labeled email templates showcasing your organizations networking community. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Email Notifications</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Showcase live events, seminars, and presentations directly to your networking community. Allow real-time comments, media and audience reactions."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Live Streaming</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  :class="{ 'br-pricing-chart__block--active': activeAdministration }"
                  class="br-pricing-chart__block">
                  <div class="br-pricing-chart__heading">
                    <h2>Administration</h2>
                    <button
                      class="button button--icon"
                      @click.prevent="toggleAdministration">
                      <i
                        :class="[ activeAdministration ? 'icon-e-delete' : 'icon-e-add' ]"
                        class="icon"/>
                    </button>
                  </div>
                  <div class="br-pricing-chart__list">
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Zenvoy will manage and support the day-to-day tasks required to keep your community running smoothly."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Community Management</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Take full control of your community’s A.I. networking:  manage profiles, edit dashboards, view trends, refine algorithms, etc."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Analytics Dashboard</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Zenvoy can integrate SSO with a host of off the shelf community and data management apps. We can also build custom integrations, contact us for more information."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Single Sign-on (SSO)</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Standalone data handling is available for clients requiring a higher level of data security."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Dedicated Server</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Zenvoy can provide support for your organization’s custom data feeds."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Custom Integrations</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="While Zenvoy is compliant HIPPA and SOC2 compliant, we can work with your organization to meet custom data handling procedures."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Custom Data Handling</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="br-pricing-chart__foot">
                <div class="br-pricing-chart__block">
                  <div class="br-pricing-chart__group">
                    <a
                      href="/schedule-demo"
                      class="button u-border-radius">
                      Talk to sales
                    </a>
                    <a href="">Learn More</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="br-pricing-chart__col br-pricing-chart__col--active">
              <div class="br-pricing-chart__head">
                <div class="br-pricing-chart__block">
                  <h1>Advanced</h1>
                  <div class="br-pricing-chart__group">
                    <div class="text-group">
                      <h4>{{ formatNumber(getPerMemberCost(3), '0,0.00') }}</h4>
                      <span class="text text--muted">person<br>/ mo</span>
                    </div>
                  </div>
                  <div class="br-pricing-chart__group">
                    <div class="text-group-vertical">
                      <span class="text text--highlight">Total {{ formatNumber(getMonthlyCostWithAddOns(3)) }} / month</span>
                      <span class="text text--muted">billed {{ model.yearly ? 'annually' : 'monthly' }} <br>+ setup charge</span>
                    </div>
                  </div>
                  <div class="br-pricing-chart__group u-pos-bottom">
                    <a
                      href="/schedule-demo"
                      class="button u-border-radius">
                      Talk to sales
                    </a>
                    <a href="/products/ai-networking-plus-summary">Learn More</a>
                  </div>
                </div>
              </div>
              <div class="br-pricing-chart__body">
                <div
                  :class="{ 'br-pricing-chart__block--active': activeAiNetworking }"
                  class="br-pricing-chart__block">
                  <div class="br-pricing-chart__heading">
                    <h2>A.I. Networking</h2>
                    <button
                      class="button button--icon"
                      @click.prevent="toggleAiNetworking">
                      <i
                        :class="[ activeAiNetworking ? 'icon-e-delete' : 'icon-e-add' ]"
                        class="icon"/>
                    </button>
                  </div>
                  <div class="br-pricing-chart__list">
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Organize and structure intelligent introductions between your people utilizing an algorithm you design."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">A.I. Matching & Intros</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Provide your people with a personalized “mini-site” showcasing your organization’s unique brand. Help convert leads by sharing their digital identity."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Virtual Business Cards</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Strategically arrange your people in cohorts to discuss questions you design. Foster valuable internal relationships, ideas, and team building opportunities. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Watercooler Cohorts</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Let us know what custom A.I. tools your organization is looking for- there’s a good chance we can build it!"
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Custom A.I. Tools</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  :class="{ 'br-pricing-chart__block--active': activeEngagement }"
                  class="br-pricing-chart__block">
                  <div class="br-pricing-chart__heading">
                    <h2>Engagement</h2>
                    <button
                      class="button button--icon"
                      @click.prevent="toggleEngagement">
                      <i
                        :class="[ activeEngagement ? 'icon-e-delete' : 'icon-e-add' ]"
                        class="icon"/>
                    </button>
                  </div>
                  <div class="br-pricing-chart__list">
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Keep your people in the loop with a personalized email digests of your organization’s networking activity. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Email Digests</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Create unique online discussion groups. Harness the power of A.I. to bring your people together around what matters. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Interest Groups</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Allow your people to communicate in private with fellow colleagues."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Direct Messaging</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Keep your people in the know by designing white-labeled email templates showcasing your organizations networking community. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Email Notifications</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Showcase live events, seminars, and presentations directly to your networking community. Allow real-time comments, media and audience reactions."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Live Streaming</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  :class="{ 'br-pricing-chart__block--active': activeAdministration }"
                  class="br-pricing-chart__block">
                  <div class="br-pricing-chart__heading">
                    <h2>Administration</h2>
                    <button
                      class="button button--icon"
                      @click.prevent="toggleAdministration">
                      <i
                        :class="[ activeAdministration ? 'icon-e-delete' : 'icon-e-add' ]"
                        class="icon"/>
                    </button>
                  </div>
                  <div class="br-pricing-chart__list">
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Zenvoy will manage and support the day-to-day tasks required to keep your community running smoothly."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Community Management</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Take full control of your community’s A.I. networking:  manage profiles, edit dashboards, view trends, refine algorithms, etc."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Analytics Dashboard</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Zenvoy can integrate SSO with a host of off the shelf community and data management apps. We can also build custom integrations, contact us for more information."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Single Sign-on (SSO)</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Standalone data handling is available for clients requiring a higher level of data security."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Dedicated Server</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Zenvoy can provide support for your organization’s custom data feeds."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Custom Integrations</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="While Zenvoy is compliant HIPPA and SOC2 compliant, we can work with your organization to meet custom data handling procedures."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Custom Data Handling</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="br-pricing-chart__foot">
                <div class="br-pricing-chart__block">
                  <div class="br-pricing-chart__group">
                    <a
                      href="/schedule-demo"
                      class="button u-border-radius">
                      Talk to sales
                    </a>
                    <a href="/products/ai-networking-enterprise-summary">Learn More</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="br-pricing-chart__col">
              <div class="br-pricing-chart__head">
                <div class="br-pricing-chart__block">
                  <h1>Enterprise</h1>
                  <div class="br-pricing-chart__group">
                    <i class="icon icon-box-3d-50-2"/>
                  </div>
                  <div class="br-pricing-chart__group u-pos-bottom">
                    <a
                      href="/schedule-demo"
                      class="button u-border-radius">
                      Contact us
                    </a>
                    <a href="/products/ai-networking-enterprise-summary">Learn More</a>
                  </div>
                </div>
              </div>
              <div class="br-pricing-chart__body">
                <div
                  :class="{ 'br-pricing-chart__block--active': activeAiNetworking }"
                  class="br-pricing-chart__block">
                  <div class="br-pricing-chart__heading">
                    <h2>A.I. Networking</h2>
                    <button
                      class="button button--icon"
                      @click.prevent="toggleAiNetworking">
                      <i
                        :class="[ activeAiNetworking ? 'icon-e-delete' : 'icon-e-add' ]"
                        class="icon"/>
                    </button>
                  </div>
                  <div class="br-pricing-chart__list">
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Organize and structure intelligent introductions between your people utilizing an algorithm you design."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">A.I. Matching & Intros</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Provide your people with a personalized “mini-site” showcasing your organization’s unique brand. Help convert leads by sharing their digital identity."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Virtual Business Cards</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Strategically arrange your people in cohorts to discuss questions you design. Foster valuable internal relationships, ideas, and team building opportunities. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Watercooler Cohorts</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Let us know what custom A.I. tools your organization is looking for- there’s a good chance we can build it!"
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Custom A.I. Tools</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  :class="{ 'br-pricing-chart__block--active': activeEngagement }"
                  class="br-pricing-chart__block">
                  <div class="br-pricing-chart__heading">
                    <h2>Engagement</h2>
                    <button
                      class="button button--icon"
                      @click.prevent="toggleEngagement">
                      <i
                        :class="[ activeEngagement ? 'icon-e-delete' : 'icon-e-add' ]"
                        class="icon"/>
                    </button>
                  </div>
                  <div class="br-pricing-chart__list">
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Keep your people in the loop with a personalized email digests of your organization’s networking activity. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Email Digests</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Create unique online discussion groups. Harness the power of A.I. to bring your people together around what matters. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Interest Groups</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Allow your people to communicate in private with fellow colleagues."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Direct Messaging</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Keep your people in the know by designing white-labeled email templates showcasing your organizations networking community. "
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Email Notifications</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Showcase live events, seminars, and presentations directly to your networking community. Allow real-time comments, media and audience reactions."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Live Streaming</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  :class="{ 'br-pricing-chart__block--active': activeAdministration }"
                  class="br-pricing-chart__block">
                  <div class="br-pricing-chart__heading">
                    <h2>Administration</h2>
                    <button
                      class="button button--icon"
                      @click.prevent="toggleAdministration">
                      <i
                        :class="[ activeAdministration ? 'icon-e-delete' : 'icon-e-add' ]"
                        class="icon"/>
                    </button>
                  </div>
                  <div class="br-pricing-chart__list">
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Zenvoy will manage and support the day-to-day tasks required to keep your community running smoothly."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Community Management</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Take full control of your community’s A.I. networking:  manage profiles, edit dashboards, view trends, refine algorithms, etc."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Analytics Dashboard</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Zenvoy can integrate SSO with a host of off the shelf community and data management apps. We can also build custom integrations, contact us for more information."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Single Sign-on (SSO)</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Standalone data handling is available for clients requiring a higher level of data security."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Dedicated Server</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="Zenvoy can provide support for your organization’s custom data feeds."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Custom Integrations</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                    <div class="br-pricing-chart__item br-pricing-chart__item--active">
                      <span
                        v-tippy="{ placement:'top', arrow:true }"
                        content="While Zenvoy is compliant HIPPA and SOC2 compliant, we can work with your organization to meet custom data handling procedures."
                        class="br-pricing-chart__note">
                        <i class="icon icon-c-question"/>
                      </span>
                      <span class="br-pricing-chart__label">Custom Data Handling</span>
                      <span class="br-pricing-chart__icon">
                        <i class="icon icon-c-check"/>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="br-pricing-chart__foot">
                <div class="br-pricing-chart__block">
                  <div class="br-pricing-chart__group">
                    <a
                      href="/schedule-demo"
                      class="button u-border-radius">
                      Contact Us
                    </a>
                    <a href="/products/ai-networking-enterprise-summary">Learn More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="br-block__pattern br-block__pattern--c">
          <img
            src="/img/patterns/dot-pattern-dark.svg"
            alt="">
        </div>
      </div>

      <div class="br-hook">
        <div class="br-hook__details">
          <p><strong>What else is included in each plan?</strong>  Check out our expanded features. </p>
        </div>
        <div class="br-hook__action">
          <a
            href="#details"
            :class="{ 'button--pulsate': !active }"
            class="button u-border-radius"
            @click.prevent="toggle">{{ active ? 'Collapse Features' : 'See all features' }}</a>
        </div>
      </div>
      <div class="br-logo-wall">
        <div class="br-logo-wall__wrapper">
          <h4>Trusted by professionals at</h4>
          <logo-carousel/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
import Slider from '@components/Slider'
import { tns } from 'tiny-slider/src/tiny-slider'
import Pricing from '@mixins/Pricing'

export default {
  components: {
    Slider
  },
  mixins: [
    Pricing
  ],
  data: () => ({
    active: false,
    activeAiNetworking: true,
    activeEngagement: false,
    activeAdministration: false
  }),
  created () {
    this.initExchangeRate()
  },
  mounted () {
    if ($(window).width() < 1024) {
      tns({
        container: '.br-pricing-chart__row',
        items: 3,
        gutter: 0,
        controls: true,
        controlsContainer: '.br-pricing-chart__controls',
        prevButton: '.br-pricing-chart__controls__prev',
        nextButton: '.br-pricing-chart__controls__next',
        nav: false,
        navContainer: false,
        autoplay: false,
        autoplayTimeout: 2000,
        autoplayButton: false,
        autoplayButtonOutput: false,
        autoplayHoverPause: false,
        loop: false,
        speed: 300,
        mouseDrag: false,
        startIndex: 0,
        responsive: {
          0: {
            disable: false,
            items: 1
          },
          1024: {
            disable: true,
            items: 3
          },
          1200: {
            items: 3
          }
        }
      })
    }
  },
  methods: {
    toggle () {
      this.active = !this.active
      this.activeEngagement = !this.activeEngagement
      this.activeAdministration = !this.activeAdministration
    },
    toggleAiNetworking () {
      this.activeAiNetworking = !this.activeAiNetworking
    },
    toggleEngagement () {
      this.activeEngagement = !this.activeEngagement
    },
    toggleAdministration () {
      this.activeAdministration = !this.activeAdministration
    }
  }
}
</script>
